/**
 * Agent Detail dataset contract — the per-org bundle behind every Agent Detail
 * sub-tab (memory, skills, tasks, autonomy, probes, evals, releases, access,
 * usage, goals). The web composes it from its per-tab data modules and the BFF
 * stores/serves it inside `OrgDataset`; both sides share these shapes. View
 * metadata (icon maps, style records, helpers) stays in the web modules.
 */
/** All-empty bundle for orgs with no seeded agent detail (empty-org safety). */
export const EMPTY_AGENT_DETAIL = {
    memory: { shared: [], private: [], scoped: [] },
    skills: { skills: [], kbRoot: [], kbSources: [], apps: [] },
    tasks: { tasks: [], schedules: [] },
    autonomy: {
        strip: [],
        metrics: [],
        budget: { period: '', used: '', cap: '', pct: 0, breakdown: [] },
        limits: [],
        decisions: [],
    },
    probes: [],
    evals: { score: '', delta: '', dims: [], runs: [], feedback: [] },
    releases: { pending: [], history: [] },
    access: { people: [], usage: [] },
    usage: {
        kpis: [],
        weekly: [],
        drivers: [],
        usageApps: [],
        usageSkills: [],
        leaders: [],
        evalSummary: { score: '', delta: '', dims: [] },
        evalSpark: [],
        usersSpark: [],
        cost: { total: '', perTask: '', perUser: '', segs: [] },
        heat: [],
    },
    goals: { goals: [], benches: [] },
};
//# sourceMappingURL=agent_detail.js.map